import { useState } from "react";
import { Tag, TagsInputWithSearch } from "#src/commonV2/TagsInputWithSearch";
import { ButtonV2 } from "#src/commonV2/Button";
import { AlertCircle } from "@untitled-ui/icons-react";
import { ModalV2 } from "#src/commonV2/modal/ModalV2";
import { ModalHeaderIcon } from "#src/commonV2/modal/ModalHeaderIcon";

const TestPage = () => {
  return (
    <div className="v2 p-8 mb-4">
      <h1 className="text-display-2xl font-bold text-black">Test Page</h1>

      {/* Tags Input With Search Example */}
      <div className="mt-8 p-4 border border-gray-v2-300 rounded-lg">
        <h2 className="text-lg font-semibold mb-4">
          Tags Input With Search Example
        </h2>
        <TagsInputWithSearchExample />
      </div>
    </div>
  );
};

// Example component for TagsInputWithSearch
const TagsInputWithSearchExample: React.FC = () => {
  const [tags, setTags] = useState<Tag[]>([
    { id: "1", name: "React", extraData: { color: "blue" } },
    { id: "2", name: "TypeScript", extraData: { color: "blue" } },
  ]);

  // This function would typically be an API call
  const searchTags = async (query: string): Promise<Tag[]> => {
    // Simulate API delay
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Example data - in a real app, this would be fetched from an API
    const allTags = [
      { id: "1", name: "React", extraData: { color: "blue" } },
      { id: "2", name: "TypeScript", extraData: { color: "blue" } },
      { id: "3", name: "JavaScript", extraData: { color: "yellow" } },
      { id: "4", name: "HTML", extraData: { color: "orange" } },
      { id: "5", name: "CSS", extraData: { color: "blue" } },
      { id: "6", name: "Next.js", extraData: { color: "black" } },
      { id: "7", name: "Node.js", extraData: { color: "green" } },
      { id: "8", name: "Redux", extraData: { color: "purple" } },
      { id: "9", name: "GraphQL", extraData: { color: "pink" } },
      { id: "10", name: "REST API", extraData: { color: "gray" } },
    ];

    // Filter tags based on the query
    return allTags.filter((tag) =>
      tag.name.toLowerCase().includes(query.toLowerCase())
    );
  };

  const [open, setOpen] = useState<boolean>(false);

  return (
    <div>
      <TagsInputWithSearch
        tags={tags}
        setTags={setTags}
        searchFunction={searchTags}
        placeholder="Search for tags..."
      />
      <div className="mt-4">
        <h3 className="text-md font-medium mb-2">Selected Tags:</h3>
        <pre className="bg-gray-v2-100 p-2 rounded">
          {JSON.stringify(tags, null, 2)}
        </pre>
      </div>
      <ButtonV2
        onClick={() => {
          setOpen(true);
        }}
      >
        Open modal
      </ButtonV2>
      <ModalV2
        open={open}
        onChangeOpen={(value) => {
          setOpen(value);
        }}
      >
        <div className="flex gap-4">
          <ModalHeaderIcon Icon={AlertCircle} />
          asdgfquiewguqwbasjbdfk
        </div>
      </ModalV2>
    </div>
  );
};

export default TestPage;
